import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=688c145a"
import script from "./UserMain.vue?vue&type=script&lang=ts"
export * from "./UserMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports